/** Why a picked file is refused before it is uploaded. */
export enum EFileUploadError {
  SIZE = 'size',
  TYPE = 'type',
}
